videojs.addLanguage('ru', {
  "New feedback": "Новое обращение",
  "Report a problem": "Сообщить о проблеме",
  "To resolve viewing issues, follow the link": "Для разрешения проблем с просмотром перейдите по ",
  "link": "ссылке",
  "Select feedback theme": "Выберите причину обращения",
  "Video problems": "Проблемы с просмотром видео",
  "Sound problems": "Проблемы со звуком",
  "Log in/sign up problems": "Проблемы со входом на сайт/регистрацией",
  "Payment problems": "Проблемы с оплатой",
  "Other problems": "Другое",
  "Feedback email": "E-mail",
  "Feedback message": "Сообщение",
  "Feedback send": "Отправить",
  "Feedback": "Сообщить о проблеме",
  "Feedback send fail": "Не удалось отправить сообщение.",
  "Feedback send success": "Сообщение успешно отправлено."
});
